import { OperatorAccess, PERMISSIONS, can } from '../../../lib/permissions';

/** Privilegio v7 que daba acceso a los informes de actividades. */
const ACTIVITIES_PRIVILEGE = 15;

type ActivityReportsAccess = OperatorAccess & {
    privileges?: readonly number[];
};

/**
 * Si el operador ve los informes de actividades. Con los roles encendidos lo
 * decide `activity.view`; con los roles apagados, el privilegio 15 de siempre.
 */
export function canSeeActivityReports({
    privileges,
    ...access
}: ActivityReportsAccess): boolean {
    if (access.rolesEnabled) return can(access, PERMISSIONS.ACTIVITY.VIEW);

    return !!privileges?.includes(ACTIVITIES_PRIVILEGE);
}
